import Vue from 'vue'
import Vuex from 'vuex'

Vue.config.devtools = true

Vue.use(Vuex)

const modules = {}

export default new Vuex.Store({
  modules: modules,
  strict: process.env.NODE_ENV !== 'production'
})
